import { useAppDispatch, useAppSelector } from "../../store/hooks/hooks";
import { t } from "i18next";
import { addNote, removeNote, setNote, setNoteP, setNoteQ } from "../../store/slices/iprCalculatorSlice";


export const NotesSection = () => {
	const notes = useAppSelector(state => state.iprCalculator.notes);
	const dispatch = useAppDispatch();
	const onNotePChange = (index: number, value: number | null) => { dispatch(setNoteP({ index, value })) };
	const onNoteQChange = (index: number, value: number | null) => { dispatch(setNoteQ({ index, value })) };
	const onNoteChange = (index: number, value: string | null) => { dispatch(setNote({ index, value })) };
	return (
		<div className="ipr__notes-block">
			<div className="ipr__notes">
				<div className="ipr__notes_title"><span>{t(`ipr:notes_title`)}</span></div>
				<div className="ipr__notes_column_names">
					<span>{t(`ipr:notes_column_p`)}</span>
					<span>{t(`ipr:notes_column_q`)}</span>
					<span>{t(`ipr:notes_column_note`)}</span>
				</div>
				{notes.map((note, i) => {
					return (<div className="ipr__note_row" key={i}>
						<span>{i + 1}:</span>
						<input
							className="ipr__note-input"
							onChange={(e) => onNotePChange(i, parseFloat(e.target.value))}
							name={`note-p-${i}`}
							id={`note-p-${i}`}
							type="number"
						/>
						<input
							className="ipr__note-input"
							onChange={(e) => onNoteQChange(i, parseFloat(e.target.value))}
							name={`note-q-${i}`}
							id={`note-q-${i}`}
							type="number"
						/>
						<input
							className="ipr__note-input"
							onChange={(e) => onNoteChange(i, e.target.value)}
							name={`note-${i}`}
							id={`note-${i}`}
							type="text"
						/>
						<button
							className="ipr__note_remove-btn"
							onClick={() => dispatch(removeNote(i))}
							aria-label={t(`ipr:note_remove`)}
						>−</button>
					</div>
					);
				})}
				<button
					className="ipr__note_add-btn"
					onClick={() => dispatch(addNote())}
					data-label={t(`ipr:note_add`)}
					aria-label={t(`ipr:note_add`)}
				>+</button>
			</div>
		</div>
	);
}